import React, { useRef, useState } from "react";
import { IdleTimer } from "./IdleTimer";
import SessionTimeoutDialog from "./SessionTimeoutDialog";
//import { logout } from "../../store/actions/User";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

let countdownInterval;
const SessionTimeout = (props) => {
  const [timeoutModalIsOpen, ToggleTimeoutModal] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  const idleTimer = useRef(null);
  let history = useHistory();

  const clearSessionInterval = () => {
    clearInterval(countdownInterval);
  };

  const handleLogout = async () => {
    try {
      ToggleTimeoutModal(false);
      clearSessionInterval();
      props.logout();
      if (props.UserReducer.companyDetails?.companyType === 'Admin') {
        history.replace('/admin/login');
      } else {
        history.replace('/login');
      };
    } catch (err) {
      console.error(err);
    };
  };

  const onAction = (e) => {
  };

  const handleContinue = () => {
    ToggleTimeoutModal(false);
    clearSessionInterval();

  };

  const onActive = () => {
    if (!timeoutModalIsOpen) {
      clearSessionInterval();
    }
  };

  const onIdle = () => {
    if (!timeoutModalIsOpen) {
      let countDown = 15;
      ToggleTimeoutModal(true);
      setTimeoutCountdown(countDown);
      countdownInterval = setInterval(() => {
        if (countDown > 0) {
          setTimeoutCountdown(--countDown);
        } else {
          handleLogout();
        }
      }, 1000);
    }
  };
  return (
    <>
      <IdleTimer
        ref={idleTimer}
        onActive={onActive}
        onIdle={onIdle}
        onAction={onAction}
        debounce={250}
        timeout={1500000}
      />
      <SessionTimeoutDialog
        countdown={timeoutCountdown}
        onContinue={handleContinue}
        onLogout={handleLogout}
        open={timeoutModalIsOpen}
      />
    </>
  );
}



const mapStateToProps = ({ UserReducer }) => ({ UserReducer });
const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    //logout
  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeout)
